import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.Details = {
  displayName: 'Details',

  onSubmit: function(onStepProgression) {
    let details = JobWizard.Details

    details.selectExactMatchForSubcategory(() => {
      if (this.hasSubcategory()) {
        details.proceedWithChosenSubcategory(onStepProgression)
      } else {
        onStepProgression()
      }
    })
  },

  buttonLayout() {
    return 'oneButton'
  },

  searchTerm() {
    return $('input[name="category"]').val()
  },

  hasSubcategory() {
    return Job.Data.category_id !== 0
  },

  proceedWithChosenSubcategory(onStepProgression) {
    let steps            = JobWizard.Steps
    let details          = JobWizard.Details
    let detailsStepIndex = details.detailsStepIndex(steps)
    let nextStep         = steps[detailsStepIndex + 1]

    if (nextStep === JobWizard.SubCategory) { // this condition avoids skipping unique question steps
      let nextStepNumber = JobWizard.StepSequence.getStepPositionByType(JobWizard.SubCategory)
      let targetStep = JobWizard.StepSequence.getStepByPosition(nextStepNumber + 1)

      JobWizard.Emitter.emit('job:wizard:advanceToStep', targetStep)
    } else {
      onStepProgression()
    }
  },

  detailsStepIndex(steps) {
    return steps.indexOf(JobWizard.Details)
  },

  selectExactMatchForSubcategory(callback) {
    let details = JobWizard.Details

    $.ajax(SS.API.V3.subCategoriesGet({ 'filter[q]': details.searchTerm(), 'filter[prefer_keywords]': '1' })).done((response) => {
      const keyword = response.meta.keyword

      if (keyword) {
        let category = { id: keyword.subcategoryID, value: keyword.subcategoryName }
        Job.Actions.updateCategory(category)
        Job.Actions.updateSubCategory(category, 'add')
        Job.Actions.updateKeyword(keyword.value)
      } else {
        for (let item of response.data) {
          if (details.searchTerm().toLowerCase() == item.attributes.name.toLowerCase()) {
            let category = { id: parseInt(item.id, 10), value: item.attributes.name }
            Job.Actions.updateCategory(category)
            Job.Actions.updateSubCategory(category, 'add')
          }
        }
      }

      callback()
    })
  },

  component: React.createClass({
    getInitialState: function() {
      return { showCategoryInput: true }
    },

    componentDidMount: function() {
      JobWizard.Emitter.addListener('job:wizard:hideCategoryInput', this.updateState)
    },

    componentWillUnmount: function() {
      JobWizard.Emitter.removeListener('job:wizard:hideCategoryInput', this.updateState)
    },

    updateState: function(data) {
      this.setState(data)
    },

    render: function() {

      return (
        <div className="form-horizontal">
          <div className={`${this.state.showCategoryInput ? '' : 'hidden'}`}>
            <div className="form-group mb24">
              <div className="col-xs-12">
                <h3 className="mb15 mt10">Who do you need?</h3>
                <JobWizard.Category />
              </div>
            </div>
          </div>

          <div className="form-group mb30">
            <div className="col-xs-12">
              <h3 className="mb15 mt10">Where are you located?</h3>
              <JobWizard.Location />
            </div>
          </div>

          <JobWizard.Origin />
        </div>
      )
    }
  })
}
